import { isShoperApp } from "./appType";

// The app embedded in Shoper (shoper.less): messaging and GROW (sign-up forms, keywords,
// coupons, automations; no QR & NFC), no Connections and no Billing; Analytics shows only the
// messaging section, Reports the messaging and GROW reports (no chats). The menu hides the
// rest and these addresses lead to the dashboard.
const HIDDEN = [
    // QR & NFC
    '/qr-and-nfc', '/qr-codes', '/nfc-signs', '/nfc-tag-groups',
    // Chat and NFC reports
    '/reports/chats', '/reports/nfc',
    // Connections
    '/widget-integrations', '/webhooks',
    // Billing
    '/new-plans', '/new-plan', '/plans', '/payments', '/balance', '/billing-data'
];
export const isHiddenInShoper = pathname => {
    const path = (pathname || '').replace(/\/+$/, '') || '/';
    return HIDDEN.some(prefix => path === prefix || path.startsWith(`${prefix}/`));
};

export const isShoperLimited = () => isShoperApp();
